/**
 * SquaresPanel — iter87.550. Player-facing Squares data hook, mirrors
 * `useMatchdayBoost` in MatchdayBoostPanel.jsx: lifted to page level
 * so TodoChips can show live status without duplicating the poll.
 */
import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export const SQUARES_TEMPLATES = [
    "nfl_squares_manual_api", "nfl_squares_auto_api",
    "cfb_squares_manual_api", "cfb_squares_auto_api",
];

export function isSquaresTemplate(tpl) {
    return SQUARES_TEMPLATES.includes(tpl);
}

export function useSquares(tournament, meId) {
    const enabled = isSquaresTemplate(tournament?.template);
    const [state, setState] = useState(null);
    // Stale-response guard — same pattern as useMatchdayBoost.
    const reqIdRef = useRef(0);
    const load = useCallback(async () => {
        if (!enabled || !tournament?.id) return;
        const rid = ++reqIdRef.current;
        try {
            const data = await api.squaresGetMyState(tournament.id, meId);
            if (rid === reqIdRef.current) setState(data);
        } catch (e) { /* best-effort, same as boost */ }
    }, [enabled, tournament?.id, meId]);
    useEffect(() => { load(); }, [load]);
    return { enabled, state, refresh: load };
}
